/**
 * @since 1.0.0
 * @author ApMod Development Team
 */
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ClientContextService } from './client-context.service';
import { LoggerService } from './logger.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { distinctUntilChanged } from 'rxjs/operators';

import { RefDataService } from './ref-data.service';
import { AuthenticationService } from './authentication.service';
import { each, union } from 'lodash-es';

export class User {
  id: number;
  firstName: string;
  lastName: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _isProd: boolean = environment.production;
  private currentUserSubject = new BehaviorSubject<any>(null);
  private _currentUser = null;
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  dynamicConfigs: any = null;

  constructor(private _apiService: ApiService,
              private _clientContextService: ClientContextService,
              private _refDataService: RefDataService,
              private _authenticationService: AuthenticationService,
              private _logger: LoggerService) {

  }

  setUser(user): void {
    // user['firstName'] = 'John';
    // user['lastName'] = 'Jones';

    /* Remove this code when API Sends user details such as first name and last name - start */
    if (user && user.name === 'TESTUSER2'){
      user['firstName'] = 'John';
      user['lastName'] = 'Jones';
    }
    else if (user && user.name === 'SUPPORTUSER'){
      user['firstName'] = 'Stan';
      user['lastName'] = 'Pickens';
    }
    else {
      user['firstName'] = 'John';
      user['lastName'] = 'Jones';
    }
    /* Remove this code when API Sends user details such as first name and last name - end */
    let permissions = [];
    if (user.roles) {
      each(user.roles, (role) => {
        permissions = union(permissions, role.permissions);
        // changed
      });
    }
    user.permissions = permissions;
    this._currentUser = user;
    this._logger.log('user ==>', user);
    this.currentUserSubject.next(user);
    this._clientContextService.setProfile(user);
  }

  getProfile(): any {
    this._logger.log('getProfile: profile first Service');
    return new Promise((resolve) => {
      this._apiService.getDynamicConfigs()
        .subscribe((data) => {
          this.dynamicConfigs = data;
          this._apiService.dynamicConfigs = data;
          this._clientContextService.clientContext.dynamicConfigs = data;
          this._onProfileComplete(resolve);
        },
          (error) => {
            if (!this._isProd) {
              this._apiService.dynamicConfigs = environment;
            }
          });

    });
  }

  private _onProfileComplete(resolve): void {
    if (this._clientContextService.getIdToken()) {
      this._authenticationService.initializeOauthService();
      resolve();
      /*this._apiService.get('/auth/user')
        .subscribe((user) => {
          this.setUser(user);
          this._refDataService.getRefData();
          resolve();
        },
          (error) => {
            this._clientContextService.setAuthorizedUser(true);
            resolve();
          }
        );*/
    }
    else {
      this._authenticationService.signIn();
      setTimeout(() => {
        // call profile complete with some delay
        this._onProfileComplete(resolve);
      }, 5000);
    }
  }

  hasPermission(neededPermissions: any = [], logicalOp: any = null): boolean {
    let hasPermission = true;

    // if(true) return true; // TODO need to set this code
    if (this._currentUser
      && this._currentUser['permissions']
    ) {
      for (const checkPermission of neededPermissions) {
        const permissionFound = this._currentUser['permissions'].find(x => x.toUpperCase() === checkPermission.toUpperCase());

        if (permissionFound) {
          hasPermission = true;

          if (logicalOp === 'OR') {
            break;
          }
        } else {
          hasPermission = false;
          if (logicalOp === 'AND') {
            break;
          }
        }
      }
    }

    return hasPermission;
  }

  getCurrentUserNavigations(): any[] {

    const navs: any[] = [

      // {
      //   id: 'dashboards',
      //   title: 'Dahsboards',
      //   translate: 'NAV.DASHBOARDS',
      //   type: 'group',
      //   children: [
      //     {
      //       id: 'dashboard',
      //       title: 'Dashboard',
      //       translate: 'NAV.DASHBOARD.TITLE',
      //       type: 'item',
      //       icon: 'dashboard',
      //       url: '/dashboard',
      //     }
      //   ]
      // },
      {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
      },
      {
        id: 'candidateSearch',
        title: 'Candidate Search',
        type: 'item',
        icon: 'person_search',
        url: '/candidates',
      },
      // {
      //   id: 'candidates',
      //   title: 'Manage Candidates',
      //   type: 'group',
      //   children: [
      //     {
      //       id: 'candidateSearch',
      //       title: 'Candidate Search',
      //       type: 'item',
      //       icon: 'person_search',
      //       url: '/candidates',
      //     }
      //   ]
      // },
      // {
      //   id: 'score_definition',
      //   title: 'Score Definition',
      //   type: 'group',
      //   children: [
      //     {
      //       id: 'score_definition',
      //       title: 'Score Definition',
      //       type: 'item',
      //       url: '/score-definition',
      //     }
      //   ]
      // },
      {
        id: 'score_definition',
        title: 'Score Definition',
        type: 'item',
        url: '/score-definition'
      },
      {
        id: 'user_management',
        title: 'User Management',
        translate: 'NAV.USER_MANAGEMENT',
        type: 'group',
        hidden: !this.hasPermission(['VIEW_USER']),
        children: [

          {
            id: 'manage_users',
            title: 'Search and Manage Users',
            translate: 'NAV.MANAGE_USERS.TITLE',
            type: 'item',
            icon: 'people',
            url: '/user-management'
          }
        ]
      },
      {
        id: 'admin',
        title: 'Admin',
        translate: 'NAV.ADMIN.TITLE',
        type: 'group',
        children: [

          {
            id: 'config_rules',
            title: 'Award Config Rules',
            type: 'item',
            icon: 'rule',
            url: 'admin/award-config-rules'
          }
        ]
      },
      {
        id: 'import_export',
        title: 'Import/Export',
        type: 'group',
        url: 'import-export/we-award-upload',
        children: [
          {
            id: 'impexp-menu',
            title: 'WE Award Upload',
            type: 'item',
            url: 'import-export/we-award-upload'
          }
        ]
      }
    ];
    return navs;
  }

}
